<template>
<div>
    <h1>digipay</h1>
</div>
</template>

<script>
// import {mapGetters, mapActions} from 'vuex';


export default {
  name: 'Digipay',
  data(){
    return{
     
    }
  },
  async mounted(){
    this.$router.push({ name: 'Today' })
  },

  

  methods: {
    // ...mapActions(['setLang', 'getBalance']),
   
  },

  props: {
  },
  components:{
  }
}
</script>

<style scoped>

</style>
